import { render, staticRenderFns } from "./EmployeeChangelogs.vue?vue&type=template&id=1eab24ec&scoped=true&"
import script from "./EmployeeChangelogs.vue?vue&type=script&lang=js&"
export * from "./EmployeeChangelogs.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeChangelogs.vue?vue&type=style&index=0&id=1eab24ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eab24ec",
  null
  
)

export default component.exports